import downloadFile from "../../functions/downloadFile.function";
import ApiResponse from "../models/ApiResponse";
import ProjectDataExportRange from "../models/ProjectDataExportRange";
import Api from "./Api";

class ExportApi {
  constructor(private api: Api) {}

  public projectDataExport(range: ProjectDataExportRange): ApiResponse<void> {
    const url = new URL("/test-request/v2/export/project-data", this.api.getBaseURL());
    url.search = new URLSearchParams({ range }).toString();
    return this.api.get(url.pathname + url.search);
  }

  public projectDataExcelExport(range: ProjectDataExportRange): Promise<void> {
    const url = new URL("/test-request/v2/export/project-data/excel", this.api.getBaseURL());
    url.search = new URLSearchParams({ range }).toString();
    return this.api
      .get(url.pathname + url.search, { responseType: "arraybuffer" })
      .then((res) => downloadFile(res, "project_data.xlsx"));
  }
}

export default ExportApi;
